import { normalize, schema } from 'normalizr';
// import { ParticipantViewModel } from 'stageclip-common';

import * as EntityNormalizers from './entityNormalizers';

const { Entity } = schema;

export const eventsSchema = new Entity('events');

export interface NormalizedEventsSendToNlpView {
  status: string;
}

export function normalizeEventsSendToNLP(
  data: NormalizedEventsSendToNlpView,
): EntityNormalizers.NormalizedSingleEntity<NormalizedEventsSendToNlpView> {
  return normalize(data, eventsSchema);
}
